import axios from 'axios';

import { IPuoLegalStatus } from '@/shared/model/puo-legal-status.model';

const baseApiUrl = 'api/puo-legal-statuses';

export default class PuoLegalStatusService {
  public find(id: number): Promise<IPuoLegalStatus> {
    return new Promise<IPuoLegalStatus>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IPuoLegalStatus): Promise<IPuoLegalStatus> {
    return new Promise<IPuoLegalStatus>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IPuoLegalStatus): Promise<IPuoLegalStatus> {
    return new Promise<IPuoLegalStatus>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
